export enum ApplicationStatus {
  NEW = 'NEW',
  CONTACTED = 'CONTACTED',
  INTERVIEW = 'INTERVIEW',
  MISSING_DOCUMENTS = 'MISSING_DOCUMENTS',
  FILE_COMPLETE = 'FILE_COMPLETE',
  NO_UPDATE = 'NO_UPDATE',
}
